import {
  GET_TRIBUN_USER_REQUEST,
  GET_TRIBUN_USER_SUCCESS,
  GET_TRIBUN_USER_FAILURE,

  SET_TRIBUN_USER_TO_BLOCKED,

  UPDATE_TRIBUN_NICKNAME_REQUEST,
  UPDATE_TRIBUN_NICKNAME_SUCCESS,
  UPDATE_TRIBUN_NICKNAME_FAILURE,

  UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST,
  UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS,
  UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE,

  UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST,
  UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS,
  UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE,

  DELETE_TRIBUN_AVATAR_REQUEST,
  DELETE_TRIBUN_AVATAR_SUCCESS,
  DELETE_TRIBUN_AVATAR_FAILURE,

  POST_TRIBUN_AVATAR_REQUEST,
  POST_TRIBUN_AVATAR_SUCCESS,
  POST_TRIBUN_AVATAR_FAILURE,

  SWITCH_TRIBUN_TAB
} from 'Store/constants';
import { PROFILE } from 'Store/constants/sportTypes';

const initialState = {
  activeTab: PROFILE,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_USER_SUCCESS:
      return { ...state, ...action.payload, isLoading: false, error: null };
    case GET_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SET_TRIBUN_USER_TO_BLOCKED:
      return { ...state, status: 'BLOCKED' };

    case UPDATE_TRIBUN_NICKNAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_NICKNAME_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false, error: null
      };
    case UPDATE_TRIBUN_NICKNAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          profile: {
            allowComment: action.payload
          }
        },
        isLoading: false, error: null
      };
    case UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          profile: {
            autoSpaceCouponShare: action.payload
          }
        },
        isLoading: false, error: null
      };
    case UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SWITCH_TRIBUN_TAB:
      return { ...state, activeTab: action.payload };

    case DELETE_TRIBUN_AVATAR_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_TRIBUN_AVATAR_SUCCESS:
      state.picture = action.payload;
      state.hasCustomProfilePhoto = !state.hasCustomProfilePhoto;
      return { ...state, isLoading: false, error: null };
      
    case DELETE_TRIBUN_AVATAR_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case POST_TRIBUN_AVATAR_REQUEST:
      return { ...state, isLoading: true, error: null };
    case POST_TRIBUN_AVATAR_SUCCESS:
      return { ...state, isLoading: false, error: null };
        
    case POST_TRIBUN_AVATAR_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
